import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Input,
  Button,
  Spinner,
  Media,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS
import { FaUsers, FaLock, FaUnlock } from "react-icons/fa"; // Import React icons for locked/unlocked users

const Blockuser = () => {
  const [users, setUsers] = useState([]); // Use state to hold user data
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false); // Loading state to show spinner
  const [filter, setFilter] = useState("all"); // State to hold the current filter

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust the number of items per page as needed

  // Fetch users from the server
  useEffect(() => {
   const fetchUsers = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem('token');
    
    // Validate token exists
    if (!token) {
      toast.error("Please log in to access user data.");
      setLoading(false);
      return;
    }

    const response = await axios.get(`${process.env.REACT_APP_API_URL}/users`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    
    if (response.data && Array.isArray(response.data.users)) {
      setUsers(response.data.users);
    } else {
      console.error("Invalid data format:", response.data);
      toast.error("Received invalid data format from server.");
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    
    // Handle specific error cases
    if (error.response?.status === 401) {
      toast.error("Session expired. Please log in again.");
      localStorage.removeItem('token'); // Clear invalid token
      // Optional: Redirect to login page
      // navigate('/login');
    } else if (error.response?.status === 403) {
      toast.error("You don't have permission to access user data.");
    } else {
      toast.error("Failed to fetch users.");
    }
  } finally {
    setLoading(false);
  }
};

    fetchUsers(); // Call the fetch function when the component mounts
  }, []); // Empty dependency array means this effect runs once when component mounts

  // Filter users based on the search term and selected filter (All, Blocked, Active)
  const filteredUsers = users.filter((user) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    // Filter by search term
    const matchesSearch =
      user.name?.toLowerCase().includes(lowerCaseSearchTerm) ||
      user.email?.toLowerCase().includes(lowerCaseSearchTerm) ||
      user.wallet?.toLowerCase().includes(lowerCaseSearchTerm) ||
      user._id?.toLowerCase().includes(lowerCaseSearchTerm);

    // Filter by user status (blocked or active)
    const matchesStatus =
      filter === "all" ||
      (filter === "blocked" && user.isblocked) ||
      (filter === "active" && !user.isblocked);

    return matchesSearch && matchesStatus;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate total number of pages
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  // Render pagination controls
  const renderPagination = () => {
    const pageNumbers = [];
    const maxPagesToShow = 3; // Number of page numbers to show at a time

    // Calculate the range of page numbers to display
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust the range if it exceeds the total number of pages
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the page numbers to display
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        {/* Previous Button */}
        <Button
          color="primary"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ margin: "0 5px", padding: "5px 10px" }}
        >
          Previous
        </Button>

        {/* Page Numbers */}
        {pageNumbers.map((number) => (
          <Button
            key={number}
            color={currentPage === number ? "primary" : "secondary"}
            onClick={() => handlePageChange(number)}
            style={{ margin: "0 5px", padding: "5px 10px" }}
          >
            {number}
          </Button>
        ))}

        {/* Next Button */}
        <Button
          color="primary"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ margin: "0 5px", padding: "5px 10px" }}
        >
          Next
        </Button>
      </div>
    );
  };

  // Handle block/unblock action
 const handleBlockUnblock = async (userId, isBlocked) => {
  const action = isBlocked ? "unblock" : "block";
  try {
    const token = localStorage.getItem('token');
    await axios.post(`${process.env.REACT_APP_API_URL}/users/${action}`, 
      { userId },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      }
    );
    toast.success(`${action === "block" ? "Blocked" : "Unblocked"} user successfully!`);

    // Update the user status in the local state
    setUsers(
      users.map((user) =>
        user._id === userId ? { ...user, isblocked: !isBlocked } : user
      )
    );
  } catch (error) {
    toast.error(`Failed to ${action} user.`);
    console.error("Error updating user status:", error);
  }
};

  return (
    <Container
      style={{
        border: "none",
        backgroundColor: "rgba(1,1,1,0.2)",
        padding: "0",
        maxWidth: "100%",
        paddingTop: "100px",
      }}
    >
      <Row
        style={{
          border: "none",
          backgroundColor: "rgba(1,1,1,0.2)",
          margin: "0",
        }}
      >
        <div className="col" style={{ padding: "0" }}>
          <Card
            style={{
              border: "none",
              backgroundColor: "rgba(1,1,1,0.2)",
            }}
          >
            <CardHeader
              className="border-0"
              style={{
                backgroundColor: "rgba(1,1,1,0.2)",
                border: "none",
              }}
            >
              <h3
                className="mb-0"
                style={{
                  color: "white",
                  fontSize: "40px",
                  fontWeight: "bolder",
                }}
              >
                User Active Status
              </h3>
            </CardHeader>

            {/* Filter Buttons */}
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
              <Button
                color="primary"
                onClick={() => setFilter("all")}
                style={{ width: "32%" }}
              >
                <FaUsers style={{ marginRight: "8px" }} />
                All
              </Button>
              <Button
                color="primary"
                onClick={() => setFilter("blocked")}
                style={{ width: "32%" }}
              >
                <FaLock style={{ marginRight: "8px" }} />
                Blocked
              </Button>
              <Button
                color="primary"
                onClick={() => setFilter("active")}
                style={{ width: "32%" }}
              >
                <FaUnlock style={{ marginRight: "8px" }} />
                Active
              </Button>
            </div>

            {/* Search input */}
            <div style={{ margin: "10px", padding: "10px" }}>
              <Input
                type="text"
                placeholder="Search by full name, email, wallet address, or ID"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  fontSize: "1rem",
                  background: "black",
                  color: "white",
                  border: "none",
                }}
              />
            </div>

            {/* Loader and Table */}
            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Spinner color="primary" />
                <p style={{ color: "white", marginTop: "10px" }}>Loading...</p>
              </div>
            ) : (
              <>
                <Table responsive style={{ width: "100%", tableLayout: "auto" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: "white",
                          fontSize: "0.7rem",
                          backgroundColor: "rgba(1,1,1,0.2)",
                          border: "none",
                        }}
                      >
                        Full Name
                      </th>
                      <th
                        style={{
                          color: "white",
                          fontSize: "0.7rem",
                          backgroundColor: "rgba(1,1,1,0.2)",
                          border: "none",
                        }}
                      >
                        Email
                      </th>
                      <th
                        style={{
                          color: "white",
                          fontSize: "0.7rem",
                          backgroundColor: "rgba(1,1,1,0.2)",
                          border: "none",
                        }}
                      >
                        Register Form Status
                      </th>
                      <th
                        style={{
                          color: "white",
                          fontSize: "0.7rem",
                          backgroundColor: "rgba(1,1,1,0.2)",
                          border: "none",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "none", fontSize: "10px" }}>
                    {currentItems.map((user) => (
                      <React.Fragment key={user._id}>
                        <tr
                          style={{
                            backgroundColor: "rgba(1,1,1,0.5)",
                            border: "none",
                            fontSize: "10px",
                            paddingLeft: "0",
                          }}
                        >
                          <th scope="row" style={{ border: "none", fontSize: "10px" }}>
                            <Media
                              className="align-items-center"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span style={{ color: "white", fontSize: "10px" }}>
                                {user.name}
                                <br />
                                {new Date(user.createdAt).toLocaleDateString()}
                              </span>
                            </Media>
                          </th>

                          <td style={{ border: "none", fontSize: "10px" }}>
                            <span style={{ color: "white", fontSize: "10px" }}>
                              {user.email}
                            </span>
                          </td>

                          <td style={{ border: "none", fontSize: "10px" }}>
                            <span style={{ color: "white", fontSize: "10px" }}>
                              {user.isblocked ? (
                                <FaLock style={{ color: "red", fontSize: "18px" }} />
                              ) : (
                                <FaUnlock style={{ color: "green", fontSize: "18px" }} />
                              )}
                            </span>
                          </td>

                          <td style={{ border: "none" }}>
                            <Button
                              size="sm"
                              color={user.isblocked ? "success" : "danger"}
                              onClick={() => handleBlockUnblock(user._id, user.isblocked)}
                            >
                              {user.isblocked ? "Unblock" : "Block"}
                            </Button>
                          </td>
                        </tr>

                        {/* New row for wallet address and user ID */}
                        <tr style={{ border: "none", paddingLeft: "0" }}>
                          <td colSpan="7" style={{ padding: "5px", border: "none", paddingLeft: "20px" }}>
                            <div style={{ color: "white", fontSize: "10px", wordWrap: "break-word" }}>
                              <strong>Wallet Address:</strong> {user.wallet}
                            </div>
                            <div style={{ color: "white", fontSize: "10px", wordWrap: "break-word" }}>
                              <strong>User ID:</strong> {user._id}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination Controls */}
                {renderPagination()}
              </>
            )}
          </Card>
        </div>
      </Row>

      {/* Toast container for showing notifications */}
      <ToastContainer />
    </Container>
  );
};

export default Blockuser;